<template>
  <section class="section">
    <div class="content">
      <h1 class="title">
        HTML to Dokuwiki
      </h1>

      <p>
        <back-button />
      </p>
    </div>

    <div class="columns">
      <div class="column">
        <textarea class="textarea" v-model="html"></textarea>
      </div>

      <div class="column">
        <textarea class="textarea" v-model="dokuwiki" readonly></textarea>
      </div>
    </div>
  </section>
</template>

<script>
import BackButton from '@/components/pages/BackButton'

/* eslint-disable */
const toWiki = function (input) {
  return input
    .replace(/\n/gi, '')
    .replace(/<h1>/gi, '===== ')
    .replace(/<h1\s[^\>]*">/gi, '===== ')
    .replace(/<\/h1>/gi, " =====\n\n")
    .replace(/<h2>/gi, '==== ')
    .replace(/<h2\s[^\>]*">/gi, '==== ')
    .replace(/<\/h2>/gi, " ====\n\n")
    .replace(/<h3>/gi, '=== ')
    .replace(/<h3\s[^\>]*">/gi, '=== ')
    .replace(/<\/h3>/gi, " ===\n\n")
    .replace(/<br>/gi, "\\\\\n")
    .replace(/<br\/>/gi, "\\\\\n")
    .replace(/<br\s\/>/gi, "\\\\\n")
    .replace(/<p>/gi, "\n\n")
    .replace(/<p\s[^\>]*">/gi, "\n\n")
    .replace(/<\/p>/gi, "\n\n")
    .replace(/\n{3,}/gi, "\n\n")
    .replace(/<a\s[^\>]*\">/gi, '')
    .replace(/<\/a>/gi, '')
    .replace(/<strong>/gi, '**')
    .replace(/<\/strong>/gi, '**')
    .replace(/<b>/gi, '**')
    .replace(/<\/b>/gi, '**')
    .replace(/<em>/gi, '//')
    .replace(/<\/em>/gi, '//')
    .replace(/<i>/gi, '//')
    .replace(/<\/i>/gi, '//')
    .replace(/<div>/gi, '')
    .replace(/<\/div>/gi, '')
    .replace(/<hr>/gi, '')
    .replace(/<hr\/>/gi, '')
    .replace(/<hr\s\/>/gi, '')
    .replace(/\&nbsp\;/gi, ' ')
    .replace(/\/{4}/gi, '')
    .replace(/\ {2,}/gi, ' ')
}

export default {
  components: {
    BackButton
  },
  data () {
    return {
      html: ''
    }
  },
  computed: {
    dokuwiki () {
      return toWiki(this.html)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/HtmlToDokuWikiPage.vue